<template id="org">
  <div>
    <br />
    <div v-if="loading" class="loading">
      <div class="text-center">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
    </div>
    <div v-else>
      <div>
        <b-row>
          <b-col cols="8">
            <h3><b-icon-building /> {{ orgDetails.login }}</h3>
            <p>
              <a
                :href="'https://github.com/' + orgDetails.login"
                target="_blank"
                v-b-tooltip.hover
                title="View on GitHub"
              >
                <span class="fa fa-github" />
                http://github.com/{{ orgDetails.login
                }}<span class="fa fa-external-link m-2" />
              </a>
            </p>
            <p id="para">{{ orgDetails.description }}</p>
          </b-col>
        </b-row>
      </div>
      <br />
      <b-card no-body>
        <b-tabs card content-class="mt-2" align="left">
          <b-tab active>
            <template v-slot:title>
              <div class="repository-title">
                <b-icon-book /> Repositories
                <b-badge v-if="items" class="repository-badge">{{ items.length }}</b-badge>
              </div>
            </template>
            <b-card-text>
              <repo-table :repos="items" :excludeColumns="['organization']" />
            </b-card-text>
          </b-tab>

          <b-tab>
            <template v-slot:title> <b-icon-clipboard /> Compliance </template>
            <b-card-text>
              <div>
                <h3><i class="fa fa-cog" aria-hidden="true"></i> Settings</h3>
                <ComplianceSettings
                  :settings="settings"
                  :updateSettings="updateSettings"
                />
              </div>
            </b-card-text>
          </b-tab>

          <b-tab>
              <template v-slot:title>
                <div class="admin-info-title">
                  <b-icon-briefcase /> Admin Info
                  <b-badge v-if="nCompleteAdminInfos" class="admin-info-badge">{{ nCompleteAdminInfos + "/" + items.length }}</b-badge>
                </div>
              </template>
              <b-card-text>
                <admin-table :adminInfos="orgExtraInfo" @ncomplete="handleNCompleteAdminInfos"/>
              </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import ComplianceSettings from "../components/ComplianceSettings.vue";
import RepoTable from "../components/RepoTable.vue";
import AdminTable from "../components/AdminTable.vue";

export default {
  name: "Org",
  data() {
    return {
      loading: true,
      items: [],
      orgId: "",
      orgName: "",
      orgDetails: "",
      orgExtraInfo: "", 
      security: null,
      nCompleteAdminInfos: 0,
    };
  },
  components: {
    ComplianceSettings,
    RepoTable,
    AdminTable,
  },
  watch: {
    // call again the method if the route changes
    $route: "Org",
  },
  created() {
    this.orgId = this.$route.params.orgid;

    Promise.all([
      this.fetchRepoData(),
      this.fetchOrgData(),
      this.fetchOrgExtraInfo(),
      this.loadComplianceSettings(),
    ]).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    async fetchRepoData() {
      this.items = await this.$client.get("organizations/" + this.orgId);
    },
    async fetchOrgData() {
      this.orgDetails = await this.$client.get(
        "organizations/orgInfo/" + this.orgId
      );
    },
    async fetchOrgExtraInfo() {
      this.orgExtraInfo = await this.$client.get("extraInfo/org/" + this.orgId);
    },
    async loadComplianceSettings() {
      this.settings = await this.$client.get(
        "complianceSettings/ORG/" + this.orgId
      );
    },
    async updateSettings() {
      await this.$client.put(
        "complianceSettings/ORG/" + this.orgId,
        this.settings
      );
    },
    handleNCompleteAdminInfos(ncomplete) {
      this.nCompleteAdminInfos = ncomplete;
    }
  },
};
</script>
<style scoped>
.admin-info-title {
  align-items: center;
}

.repository-title {
  align-items: center;
}

.repository-badge {
  margin-left: 5px; /* Adjust this value as needed */
  margin-top: 0px; /* Adjust this value as needed */
  vertical-align: middle;
}

.admin-info-badge {
  margin-left: 5px; /* Adjust this value as needed */
  margin-top: 0px; /* Adjust this value as needed */
  vertical-align: middle;
}
</style>